module.exports = __webpack_public_path__ + "static/media/SaoPaulo_kmeans_202_50.e0a77add.csv";